<template>
  <legal-document title="Согласие на обработку персональных данных" type="personal-data-agreement" />
</template>

<script>
import LegalDocument from './../../components/legal/LegalDocument';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Согласие на обработку персональных данных'),
    }
  },

  components: {
    LegalDocument,
  },
}
</script>
